export default __webpack_public_path__ + "static/media/machine.5b4cb2f3.png";